// TOOD: Add authentication headers to all sent requests
const request = async (url, options) => fetch(
    url,
    {
        headers: {"Content-Type": "application/json"},
        ...options
    }
).then(res => {
    try {
        return res.json()
    } catch (e) {
        try {
            return res.body()
        } catch (e2) {
            return null
        }
}}).catch(console.error)

const qs = (obj = {}) => new URLSearchParams(obj).toString()
export const get = (url, body = {}, options = {}) => request(`${url}${body ? `?${qs(body)}` : ""}`, { ...options, method: "GET" })
export const post = (url, body = {}, options = {}) => request(url, { ...options, method: "POST", body: JSON.stringify(body) })
export const put = (url, body = {}, options = {}) => request(url, { ...options, method: "PUT", body: JSON.stringify(body) })
export const del = (url, body = {}, options = {}) => request(url, { ...options, method: "DELETE", body: JSON.stringify(body)})
// TODO: Add PATCH and DELETE handlers